import axios from "axios";

const getInstantLuckyDrawDetail = ({ id }) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`/campaignV2/customer/instantLuckyDraw/detail?id=${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};
export default getInstantLuckyDrawDetail;
